var app = app || {};

app.flexslider = (function ($) {

	flexsliderInit = function() {
        $('.flexslider').each(function(_, el) {
            var animation = $(el).data('flex-animation') || "fade";
            var controlnav = $(el).is('[data-flex-control]') ? true : false;
            var slideshow = $(el).is('[data-flex-slideshow]') ? true : false;
            var directionnav = $(el).is('[data-flex-direction]') ? true : false;
            var flexspeed = $(el).data('flex-speed') ? $(el).data('flex-speed') : 5000;
            $(el).flexslider( {
                animation: animation,
                slideshow: slideshow,
                controlNav: controlnav,
                directionNav: directionnav,
                slideshowSpeed: flexspeed,
                randomize: true,
                pauseOnAction: false,
                start: function(slider) {
                    slider.removeClass('carousel--loading');
                }
            });
        });
	},
    init = function () {
    	flexsliderInit();
    };
    return {
        init: init
    }    	

}( jQuery, this ));

jQuery(app.flexslider.init);